import { ButtonSize, ButtonVariant } from "@galaxy-io/dls/buttons/Button";
import Dropdown from "@galaxy-io/dls/dropdown/Dropdown";
import Flex, { AlignItems, FlexDirection, JustifyContent } from "@galaxy-io/dls/layout/Flex";
import Text, { TextSize, TextVariant, TextWeight } from "@galaxy-io/dls/text/Text";
import { Placement } from "@galaxy-io/dls/theme/enums";
import { FunnelIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";

export function FilterPopover({
  open,
  onOpenChange,
  count,
  invalid = false,
  onReset,
  onApply,
  disabled = false,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  count: number;
  invalid?: boolean;
  onReset: () => void;
  onApply: () => void;
  disabled?: boolean;
  children: ReactNode;
}) {
  return (
    <Dropdown
      isOpen={open}
      onOpenChange={onOpenChange}
      placement={Placement.BOTTOM_END}
      ariaLabel="Filters"
      header={
        <Flex direction={FlexDirection.COLUMN} gap={4} padding={8}>
          <Text weight={TextWeight.MEDIUM}>Filter records</Text>
          <Text size={TextSize.BODY_SM} variant={TextVariant.SECONDARY}>
            Set your conditions, then apply to this view.
          </Text>
        </Flex>
      }
      body={
        <Flex
          direction={FlexDirection.COLUMN}
          gap={24}
          padding={12}
          width="max-content"
          maxWidth="calc(100vw - 48px)"
        >
          {children}
        </Flex>
      }
      footer={
        <Flex
          padding={8}
          alignItems={AlignItems.CENTER}
          justifyContent={JustifyContent.SPACE_BETWEEN}
          gap={16}
        >
          <Button
            label="Reset"
            size={ButtonSize.SMALL}
            variant={ButtonVariant.TERTIARY}
            onClick={onReset}
          />
          <Flex gap={8}>
            <Button
              label="Cancel"
              size={ButtonSize.SMALL}
              variant={ButtonVariant.SECONDARY}
              onClick={() => onOpenChange(false)}
            />
            <Button
              label="Apply filters"
              size={ButtonSize.SMALL}
              isDisabled={disabled}
              onClick={onApply}
            />
          </Flex>
        </Flex>
      }
    >
      <Button
        label={invalid ? "Filters · Invalid" : count ? `Filters · ${count}` : "Filters"}
        icon={FunnelIcon}
        variant={ButtonVariant.SECONDARY}
        size={ButtonSize.SMALL}
      />
    </Dropdown>
  );
}
